"use strict";

/* global warta_review_post_user_rating_frontend, parseFloat */

/**
 * User rating.
 * 
 * @since 1.0.0
 * @version 1.0.0
 * @author FriskaMax <support@friskamax.com>
 * @param {jQuery} $
 * @returns {undefined}
 */
(function ($) {
  'use strict';

  var EVENT_NAMESPACE = '.frontend.user-rating.warta-review-post';
  var EVENT = {
    RATED: "rated".concat(EVENT_NAMESPACE)
  };
  var SELECTOR = {
    CONTAINER: '.warta-review-post-box',
    RATEIT: '.rateit',
    USER_RATING: '.user-rating',
    AFTER_VOTE: '.after-vote',
    VOTE_VALUE: '.vote-value',
    VOTE_COUNT: '.vote-count'
  };
  $(document).on(EVENT.RATED, "".concat(SELECTOR.CONTAINER, " ").concat(SELECTOR.RATEIT), function (event, value) {
    var $this = $(this);
    $.getJSON(warta_review_post_user_rating_frontend.rest_url, {
      id: $this.data('id'),
      value: value
    }, function (response) {
      var $wrapper = $this.closest(SELECTOR.USER_RATING);
      $this.rateit('readonly', true).attr('title', value);
      $wrapper.find(SELECTOR.AFTER_VOTE).css('display', 'block');
      $wrapper.find(SELECTOR.VOTE_VALUE).text(response.value);
      $wrapper.find(SELECTOR.VOTE_COUNT).text(response.count);
    });
  });
})(jQuery);